// extracted by mini-css-extract-plugin
module.exports = {"container":"works_container__2aqW6","wrapper":"works_wrapper__hk60u","images":"works_images__1RKlw","pagenation":"works_pagenation__13MOS","modal":"works_modal__39Y1y"};